import React from 'react';
import { useTranslation } from 'react-i18next';
import ThumbMiddleContent from '@wix/da-ds/pkg/thumbs/legos/ThumbMiddleContent';
import ThumbStatusIndicator from '@wix/da-ds/pkg/thumbs/ThumbStatusIndicator';
import HoverOnly from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverOnly';
const BlockedSubscribedMiddleContent = ({ thumbWidth, thumbHeight, className })=>{
    const { t } = useTranslation();
    const canShowDescription = thumbHeight && thumbHeight > 200 && thumbWidth && thumbWidth > 280;
    const isUnreasonablySmall = thumbHeight && thumbHeight < 150;
    if (isUnreasonablySmall) {
        return /*#__PURE__*/ React.createElement(HoverOnly, {
            reverseHidden: true
        }, /*#__PURE__*/ React.createElement(ThumbMiddleContent, {
            icon: /*#__PURE__*/ React.createElement(ThumbStatusIndicator, {
                type: "in-tier",
                size: "large"
            }),
            className: className
        }));
    }
    return /*#__PURE__*/ React.createElement(ThumbMiddleContent, {
        icon: /*#__PURE__*/ React.createElement(ThumbStatusIndicator, {
            type: "in-tier",
            size: "large"
        }),
        subtitle: canShowDescription ? t('deviationview.overlay.subscriber.locked') : undefined,
        className: className
    });
};
BlockedSubscribedMiddleContent.displayName = 'BlockedSubscribedMiddleContent';
export default BlockedSubscribedMiddleContent;
